import * as React from 'react';
import { FormComponentProps } from 'antd/lib/form/Form';
import FormControl from 'components/Forms/FormControl/FormControl';
import { RouteComponentProps, withRouter } from 'react-router';
import ForgetPasswordCompleteFormHandler from './ForgetPasswordCompleteFormHandler';
import { ResetPasswordModel } from 'Core/Api/UserManagement/Api';
import { FormItemProps } from 'antd/lib/form';
import { Button, Form, Input, notification, Icon, Row, Col } from 'antd';
import { PageContainerRow } from 'components/CartManagement/CartOverviewView/CartOverviewView.Style';
import {
  PageContainerCol,
  PageContainerColLayout,
  CenterAlignRow,
  centeredRowAttributes,
  LeftAlignRow,
} from 'components/Styled/Layout.Styled';
import { NavLink } from 'react-router-dom';
import ValidationUtility from 'Core/ValidationUtility';
import NotificationUtility from 'Core/NotificationUtility';
import { Helmet } from 'react-helmet';

export interface Props extends FormItemProps, FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {
  emailAddress: string;
  passwordResetToken: string;
  newPassword: string;
  confirmPassword: string;
  confirmTrue: boolean;
  passChangeSuccess: false;
  errorMessage: string;
  passwordStrength: string;
  placeholder: string;
}

class ForgetPasswordCompleteFormWithoutRouterAndForm extends React.Component<
  Props & FormComponentProps,
  State
> {
  individualForgetPasswordCompleteHandler: ForgetPasswordCompleteFormHandler;
  constructor(props: Props & FormComponentProps) {
    super(props);
    this.individualForgetPasswordCompleteHandler = new ForgetPasswordCompleteFormHandler(props);
    this.state = {
      emailAddress: '',
      passwordResetToken: '',
      newPassword: '',
      confirmPassword: '',
      confirmTrue: false,
      passChangeSuccess: false,
      errorMessage: '',
      passwordStrength: '',
      placeholder: '',
    };
    this.validateToNextPassword = this.validateToNextPassword.bind(this);
    this.compareToFirstPassword = this.compareToFirstPassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateNewPassword = this.validateNewPassword.bind(this);
    this.resendForgetPassword = this.resendForgetPassword.bind(this);
  }

  validateNewPassword = (rule, value, callback) => {
    let password = value;
    let errorMessage;
    let capsCount, smallCount, numberCount, symbolCount;
    if (!password) {
      return null;
    }
    if (password.length < 8) {
      callback('password must be min 8 char');
    } else {
      capsCount = (password.match(/[A-Z]/g) || []).length;
      smallCount = (password.match(/[a-z]/g) || []).length;
      numberCount = (password.match(/[0-9]/g) || []).length;
      symbolCount = (password.match(/\W/g) || []).length;
      if (capsCount < 1) {
        errorMessage = 'must contain caps';
      } else if (smallCount < 1) {
        errorMessage = 'must contain small';
      } else if (numberCount < 1) {
        errorMessage = 'must contain number';
      } else if (symbolCount < 1) {
        errorMessage = 'must contain symbol';
      }
      callback(errorMessage);
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmTrue) {
      form.validateFields(['primaryUser.confirmPassword'], { force: true });
    }
    callback();
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('primaryUser.password')) {
      callback('Two passwords that you enter are inconsistent!');
    } else {
      callback();
    }
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values: ResetPasswordModel) => {
      if (!err) {
        this.individualForgetPasswordCompleteHandler
          .ResetPassword(values)
          .then(() => {
            NotificationUtility.success(
              'Success',
              'Submission was successful, your password has been reset successfully',
              10,
              true
            );
            this.props.history.push('/login');
          })
          .catch(x => {
            NotificationUtility.error('Error Completing Password Reset', x.message ?? x, 20, true);
          });
      }
    });
  };

  resendForgetPassword = () => {
    this.props.history.push('/forget-password');
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 9 },
        sm: { span: 9 },
      },
      wrapperCol: {
        sm: { span: 15 },
      },
    };

    const { getFieldDecorator } = this.props.form;

    return (
      <PageContainerRow {...centeredRowAttributes}>
        <Helmet>
          <title>Forget Password Confirmation</title>
        </Helmet>
        <PageContainerCol {...PageContainerColLayout}>
          <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
            <Row>
              <Col>
                <p>
                  The token has been sent to your email, please enter email address, token and your
                  new password. If you didn't get a email or the token has expired, you can send
                  another token <NavLink to="/forget-password">here</NavLink>.
                </p>
              </Col>
            </Row>
            <LeftAlignRow>
              <Col>
                <Form {...formItemLayout} labelAlign="left" onSubmit={this.handleSubmit}>
                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[
                      ...ValidationUtility.getRequired('Please enter your email'),
                      { type: 'email', message: 'This input is not a valid email' },
                    ]}
                    name="emailAddress"
                    label="Email Address">
                    <Input
                      prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      placeholder=""
                    />
                  </FormControl>

                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[...ValidationUtility.getRequired('Please enter token')]}
                    name="passwordResetToken"
                    label="Password Reset Token">
                    <Input />
                  </FormControl>

                  <FormControl
                    className="third_row"
                    getFieldDecorator={getFieldDecorator}
                    rules={[
                      ...ValidationUtility.getStrongPassword(),
                      ...ValidationUtility.getRequired('Please enter your password'),
                      { validator: this.validateToNextPassword },
                    ]}
                    name="password"
                    label="Password">
                    <Input.Password
                      prefix={
                        <Icon type="lock" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />
                      }
                      placeholder="Password"
                    />
                  </FormControl>

                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[
                      { required: true, message: 'Please confirm your password' },
                      ...ValidationUtility.getCompareField(
                        this.props.form,
                        'password',
                        'Passwords do not match'
                      ),
                    ]}
                    name="confirmPassword"
                    label="Confirm Password">
                    <Input.Password
                      prefix={
                        <Icon type="lock" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />
                      }
                      placeholder="Confirm Password"
                    />
                  </FormControl>
                  <Row align="middle" justify="space-between">
                    <Col xs={{ span: 24 }} lg={{ span: 24, offset: 10 }} >
                      <Row style={{ marginBottom: 8 }}>
                        <Button style={{ width: 180 }} size="default" type="primary" htmlType="submit">   Update Password </Button>
                      </Row>
                      <Row style={{}}>
                        <Button style={{ textOverflow: 'wrap', width: 180 }} size="default" onClick={this.resendForgetPassword}>Resend Forgot Password</Button>
                      </Row>

                    </Col>
                  </Row>
                </Form>
              </Col>
            </LeftAlignRow>
          </Row>
        </PageContainerCol>
      </PageContainerRow >
    );
  }
}

const ForgetPasswordCompleteFormWithoutRouter = Form.create<Props>({
  name: 'forgetpasswordcompleteform',
})(ForgetPasswordCompleteFormWithoutRouterAndForm);

const ForgetPasswordCompleteForm = withRouter(ForgetPasswordCompleteFormWithoutRouter);

export default ForgetPasswordCompleteForm;
